export default {
      id: "login-google-usage",
      viewBox: "0 0 17 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-google-usage",
      toString: function () {
        return this.url;
      }
    }